import _ from 'lodash';
import { DetailServiceSymbol } from '@/services/DetailService';
import { injectService } from '@/inversify.config';
const detailService = injectService(DetailServiceSymbol);
function processSortString(sort) {
    if (!sort)
        return '';
    const sorts = sort.split(',');
    if (sorts && sorts.length > 1)
        return sort;
    if (sort.length > 30 && sort.indexOf(':') === -1) {
        return `${sort}:asc`;
    }
    return sort;
}
class FolderSort {
    static getLocalKey(spaceId, type = detailService.detailType) {
        // @ts-ignore
        if (type === 'patent') {
            return `folder-sort-${spaceId}`;
        }
        return `folder-sort-${spaceId}-${type}`;
    }
    static functionalRead(spaceId, folderId, detailType = detailService.detailType) {
        try {
            const localKey = FolderSort.getLocalKey(spaceId, detailType);
            const sortStatus = JSON.parse(localStorage.getItem(localKey)) || {};
            const sort = _.get(sortStatus, folderId);
            return processSortString(sort);
        }
        catch (e) {
            console.error(e);
        }
        return '';
    }
    static functionalWrite(spaceId, folderId, sortKey, detailType = detailService.detailType) {
        const localKey = FolderSort.getLocalKey(spaceId, detailType);
        if (!localStorage)
            return localKey;
        try {
            const sortStatus = JSON.parse(localStorage.getItem(localKey)) || {};
            sortStatus[folderId] = sortKey;
            localStorage.setItem(localKey, JSON.stringify(sortStatus));
        }
        catch (e) {
            console.error(e);
        }
        return localKey;
    }
    constructor(spaceId) {
        this.sortStatus = {};
        this.localKey = FolderSort.getLocalKey(spaceId);
        if (!localStorage) {
            this.sortStatus = {};
            return;
        }
        this.sortStatus = JSON.parse(localStorage.getItem(this.localKey)) || {};
    }
    addfolderSort(folderId, sort) {
        this.sortStatus[folderId] = sort;
        this.sync();
    }
    getFolderSort(folderId) {
        const sort = _.get(this.sortStatus, folderId);
        return processSortString(sort);
    }
    sync() {
        if (!localStorage)
            return;
        localStorage.setItem(this.localKey, JSON.stringify(this.sortStatus));
    }
    static dellAllFolders(spaceId) {
        if (!localStorage)
            return;
        localStorage.removeItem(FolderSort.getLocalKey(spaceId));
    }
}
export default FolderSort;
